import { Icon } from '@hum/ui-library';

export const fileIconMap = {
  'text/csv': Icon.CsvFile,
  'application/vnd.ms-excel': Icon.ExcelFile,
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
    Icon.ExcelFile,
  default: Icon.DefaultFile,
};
